<div class="new-filter-row">
  <div class="subtitles">
    <fieldset class="side-by-side">
      <legend>Legenda (Cores de fundo)</legend>
      <div class="red">
        <p-checkbox
          value="red"
          class="clickable"
          type="checkbox"
          class="checkbox"
        ></p-checkbox>
        Dados Incompletos
      </div>
      <div class="blacklist-legend">
        <span class="blacklist-badge">Bloqueado</span>
        Blacklist
      </div>
    </fieldset>
    <div class="new-form-button">
      <button
        type="button"
        pButton
        icon="pi pi-ban"
        label="Blacklist"
        class="p-button-outlined p-button-danger blacklist-button"
        (click)="openBlacklist()"
      ></button>
      <div class="p-inputgroup">
        <input
          type="text"
          pInputText
          placeholder="Filtro por nome, documento e telefone"
          [(ngModel)]="searchText"
          (input)="filterTable()"
          style="width: 320px"
          class="input-search"
        />
        <button
          type="button"
          pButton
          [ngClass]="{'white': searchText}"
          [icon]="searchText ? '' : 'pi pi-search'"
          [label]="searchText ? 'Limpar' : ''"
          (click)="clearSearch()"
        ></button>
      </div>
    </div>
  </div>
</div>
<div class="table">
  <p-table
    #visitorDataTable
    [value]="visitorList"
    [paginator]="true"
    [rows]="numberOfRows"
    [rowsPerPageOptions]="[500, 1000]"
    dataKey="id"
    sortMode="multiple"
    csvSeparator=";"
    [totalRecords]="totalRecords"
    styleClass="easy-table"
    [alwaysShowPaginator]="true"
    autoLayout="true"
  >
    <ng-template pTemplate="caption">
      <div class="table-header">
        <div></div>
        
        <span class="right" style="font-weight: bold; margin-top: 5px">
          {{ "TOTAL-REGISTERS" | translate }}: {{ visitorList?.length }}
          {{ "OF" | translate }} {{ totalRecords }}
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'federalId'">
          {{ "CPF" | translate }}
          <p-sortIcon [field]="'federalId'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'name'">
          {{ "NAME" | translate }}
          <p-sortIcon [field]="'name'"></p-sortIcon>
        </th>

        <th >
          {{ "PHOTO" | translate }}
          
        </th>

        <th>
          {{ "Autorizado por:" | translate }}
        </th>
        <th [pSortableColumn]="'phone'">
          {{ "PHONE" | translate }}
          <p-sortIcon [field]="'phone'"></p-sortIcon>
        </th>
        <th class="text-center" [pSortableColumn]="'lastPermissionDate'">
          {{ "Última Permissão" | translate }}
          <p-sortIcon [field]="'lastPermissionDate'"></p-sortIcon>
        </th>
        <th class="text-center" [pSortableColumn]="'active'">
          {{ "Status Atual" | translate }}
          <p-sortIcon [field]="'active'"></p-sortIcon>
        </th>
        <th class="text-center">{{ "Ações" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-visitor>
      <tr>
        <td [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }">
          {{ visitor.federalId }}
        </td>
        <td [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }">
          {{ visitor.name }}
        </td>
        <td [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }">
          <img
            *ngIf="visitor.photoUrl"
            [src]="visitor.photoUrl"
            alt="Foto do Visitante"
            class="photo"
          />
        </td>
        <td [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }">
          {{
            getLastPermission(visitor.accessPermissions)
              ?.customerResponsibleName
          }}
        </td>
        <td [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }">
          {{ visitor?.phone }}
        </td>
        <td
          [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }"
          class="text-center"
        >
          {{
            getLastPermission(visitor.accessPermissions)?.createDate
              | date : "dd/MM/yyyy"
          }}
        </td>
        <td
          [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }"
          class="text-center"
        >
          {{ visitor.active ? "Ativo" : "Inativo" }}
          <span *ngIf="isBlacklisted(visitor)" class="blacklist-badge"
            >Bloqueado</span
          >
        </td>

        <td
          [ngClass]="{ incomplete: hasIncompleteVisitorData(visitor) }"
          class="text-center"
        >
          <p-menu
            appendTo="body"
            #menu
            [model]="menuItems"
            [popup]="true"
            [showTransitionOptions]="'150ms'"
            [hideTransitionOptions]="'150ms'"
          ></p-menu>
          <button
            (click)="menu.toggle($event); changeSelectedItem(visitor)"
            pButton
            type="button"
            icon="pi pi-ellipsis-v"
            class="p-button-text p-button-rounded p-button-lg"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
